<script setup lang="ts">
import type { InvestigationChapterCollectionItem } from '@nuxt/content'

const props = defineProps<{
  page: InvestigationChapterCollectionItem
}>()
</script>

<template>
  <div class="relative isolate mb-8 flex h-60 items-center justify-center overflow-hidden text-pretty rounded border-b border-b-neutral-700 bg-neutral-600 text-center font-heading text-4xl font-semibold tracking-wide text-neutral-100 text-shadow lg:h-[30rem] lg:text-5xl">
    <h2 class="relative z-10">
      {{ props.page.title }}
    </h2>
    <ImageCover :src="props.page.image.src" class="absolute inset-0 z-0 w-full opacity-70 mix-blend-overlay grayscale" />
  </div>
</template>
